import * as React from 'react';
import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';

import {
  renderTextWithFootnotesReferencesV2,
  ConsumptionsAndEmissions,
} from '@oneaudi/feature-app-utils';
import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { OneGraphServiceV1 } from '@oneaudi/onegraph-service';
import type { Logger } from '@feature-hub/logger';

const LegalInfoContainer = styled.div`
  margin-block-start: var(--spacing-relative-md);
`;

interface Props {
  consumptionAndEmissions: string[];
  disclaimers?: string[];
  localeService: LocaleServiceV1;
  oneGraphService: OneGraphServiceV1;
  loggerService?: Logger;
}

const disclaimerFontSize = process.env.IS_LEGACY ? '2' : '3';

export const LegalInfo: React.FC<Props> = ({
  disclaimers,
  consumptionAndEmissions,
  oneGraphService,
  localeService,
  loggerService,
}) => (
  <LegalInfoContainer>
    {consumptionAndEmissions && (
      <Text
        variant={{ type: 'copy', order: disclaimerFontSize, style: 'normal' }}
        margin={[0, 0, `${Number(disclaimers?.length) > 0 ? 'var(--spacing-relative-xs)' : 0}`, 0]}
      >
        <ConsumptionsAndEmissions
          ids={consumptionAndEmissions}
          localeService={localeService}
          oneGraphService={oneGraphService}
          logger={loggerService}
        />
      </Text>
    )}
    {disclaimers?.map((x, i) => (
      <Text
        key={[i, x].join('_')}
        variant={{ type: 'copy', order: disclaimerFontSize, style: 'normal' }}
      >
        {renderTextWithFootnotesReferencesV2(x)}
      </Text>
    ))}
  </LegalInfoContainer>
);
